import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { getEnvironmentLabel } from '../../utils/environment';
import './BrgHeader.css';

export function BrgHeader() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleLogout = () => {
    setMenuOpen(false);
    auth.logout();
    navigate('/login', { replace: true });
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="brg-header">
      <div className="brg-header-content">
        <div className="brg-logo-section">
          <img src="/tfc-logo.png" alt="TFC Logo" className="tfc-logo" />
          <h1 className="brg-title">Business Resource Groups{getEnvironmentLabel()}</h1>
        </div>
        {auth.isAuthenticated && (
          <div className="brg-user-menu" ref={menuRef}>
            <button
              className="brg-user-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="User menu"
              aria-expanded={menuOpen}
            >
              <span className="brg-user-avatar">
                {auth.name ? auth.name.charAt(0).toUpperCase() : 'U'}
              </span>
              <span className="brg-user-name">{auth.name || 'User'}</span>
              <span className="brg-user-caret">▾</span>
            </button>
            {menuOpen && (
              <div className="brg-user-dropdown">
                <div className="brg-user-dropdown-info">
                  <span className="brg-user-dropdown-name">{auth.name}</span>
                  <span className="brg-user-dropdown-email">{auth.email}</span>
                </div>
                <hr className="brg-user-dropdown-divider" />
                <button className="brg-user-dropdown-item" onClick={handleLogout}>
                  Log out
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
